import {
  ActionReducerMap,
  createFeatureSelector,
  MemoizedSelector
} from '@ngrx/store';

import * as fromAccountInformation from './account-information.reducer';
import * as fromAccountInvoices from './account-invoices.reducer';
import * as fromUserInformation from './user-information.reducer';

export interface AccountState {
  accountInformation: fromAccountInformation.AccountInformationState;
  userInformation: fromUserInformation.UserInformationState;
  accountInvoices: fromAccountInvoices.AccountInvoicesState;
}

export const reducers: ActionReducerMap<AccountState> = {
  accountInformation: fromAccountInformation.reducer,
  userInformation: fromUserInformation.reducer,
  accountInvoices: fromAccountInvoices.reducer
};

export const getAccountState: MemoizedSelector<
  object,
  AccountState
> = createFeatureSelector<AccountState>('accountInformation');
